import { Injectable } from '@angular/core';
import { ButtonConfirmComponent } from '@ui-kit/buttons';

@Injectable({ providedIn: 'root' })
export class ConfirmTrackerService {
    private activePopconfirm?: ButtonConfirmComponent | undefined;

    register(component: ButtonConfirmComponent) {
        if (this.activePopconfirm && this.activePopconfirm !== component) {
            this.activePopconfirm.closePopconfirm();
        }
        this.activePopconfirm = component;
    }

    clear(component: ButtonConfirmComponent) {
        if (this.activePopconfirm === component) {
            this.activePopconfirm = undefined;
        }
    }
}
